import { times } from 'lodash';
import createTaskType from '../../createTaskType';
import InformationTextEditor from './Editor';

export default createTaskType({
    id: 'information_text_a2',
    label: 'Information Text',
    skill: 'reading_writing',
    v2: true,
    hasRubric: true,

    rubric: {
        convertToLocalFormat(task) {
            task.items = task.items.map((item, index) => {
                item.index = index;
                item.page = parsePage(item.page);
                return item;
            });
            return task;
        }
    },

    editor: InformationTextEditor,

    createItemsTemplate: () => [...times(8, createItem)],

    convertToLocalFormat(task) {
        task.items = task.items.map((item, index) => {
            item.index = index;
            item.page = parsePage(item.page);
            return item;
        });
        return task;
    },

    convertToUploadFormat(task) {
        const bgImage = task.items[0]?.background_image ?? '';

        task.items = task.items.map((item, idx) => {
            if (idx >= 1 && idx <= 3) {
                item.background_image = bgImage;
            }
            delete item.index;
            item.page = item.page ? `PAGE_${item.page}` : null;
            return item;
        });

        return task;
    },

    getKeys: (item) => {
        const correct_answer = item.answers.find(x => x.is_correct_answer);
        return [correct_answer.text];
    }
});

const DEFAULT_ORDER = [
    [1, 2, 3],
    [4, 5, 6],
    [7, 8, 9],
    [10, 11, 12],
    [13, 14, 15],
    [16, 17, 18],
    [19, 20, 21],
    [22, 23, 24]
];

function parsePage(page) {
    const pageParts = page?.split('PAGE_') ?? [];
    return pageParts.length === 2 ? parseInt(pageParts[1]) : null;
}

function createItem(index) {
    const is_example = index === 0;
    const page = index <= 3 ? 1 : 2;

    return {
        index,
        page,
        background_image: '',
        is_example,
        ...(is_example && { rubric_id: '' }),
        stimulus_text: '',
        answers: times(DEFAULT_ORDER[index].length, (i) => ({
            is_correct_answer: i === 0,
            text: '',
            display_order: DEFAULT_ORDER[index][i]
        }))
    };
}
